import React, { useContext, useEffect, useMemo, useState } from "react";
import PolarAreaChart from "../../../PolarAreaChart/PolarAreaChart";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { useGroupReportDate } from "../../../../Context/GroupReportDate";
import "./LeadershipStyle2.scss";
import { initialDataLeaderShip } from "../groupReport-pdf/QuadrantInFocus";
import LeaderShipStarterChart from "../groupReport-pdf/LeaderShipStarterChart";

const CHART_ORDER = ["strategic", "visionary", "performance", "collaborative"];


const QUADRANT_SCORE_KEY = {
  PERFORMANCE: 1,
  STRATEGIC: 2,
  VISIONARY: 3,
  COLLABORATIVE: 4,
};

const normalizeKey = (k = "") => {
  const s = String(k).toLowerCase().trim();
  if (s === "strategy") return "strategic";
  if (s === "collabrative") return "collaborative";
  return s;
};

export default function LeadershipStyle2({
  apiData,
  previewData,
  onDataCalculated,
  reportType,
  pageNumber,
}) {
  const groupReportCtx = useContext(GroupReportContext);
  const { averagePercentagesLeadership } = groupReportCtx;
  const { updateLeaderchartdata } = useGroupReportDate();

  const [valuesSVPC, setValuesSVPC] = useState([0, 0, 0, 0]);
  const [labels, setLabels] = useState(CHART_ORDER);
  const [winner, setWinner] = useState("");
  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);

  useEffect(() => {
    const s = averagePercentagesLeadership?.find((el) => el?.name === "Strategic")?.avg ?? 0;
    const v = averagePercentagesLeadership?.find((el) => el?.name === "Visionary")?.avg ?? 0;
    const p = averagePercentagesLeadership?.find((el) => el?.name === "Performance")?.avg ?? 0;
    const c = averagePercentagesLeadership?.find((el) => el?.name === "Collaborative")?.avg ?? 0;

    const vals = [(Number(s.toFixed(2)) || 0), (Number(v.toFixed(2)) || 0), (Number(p.toFixed(2)) || 0), (Number(c.toFixed(2)) || 0)];
    const valschartPdf = [(Number(p.toFixed(2)) || 0), (Number(c.toFixed(2)) || 0), (Number(v.toFixed(2)) || 0), (Number(s.toFixed(2)) || 0)];
    setValuesSVPC(vals);
    setLabels(CHART_ORDER);
    updateLeaderchartdata(valschartPdf)

    const maxVal = Math.max(...vals);
    const maxIdx = vals.indexOf(maxVal);
    const w = CHART_ORDER[maxIdx] || "";
    setWinner(w);
  }, [averagePercentagesLeadership]);

  // console.log("averagePercentagesLeadership",averagePercentagesLeadership)

  const dataForPolar = useMemo(() => {
    const [s = 0, v = 0, p = 0, c = 0] = valuesSVPC;
    return [p, c, v, s];
  }, [valuesSVPC]);


  const allVariableSets = useMemo(() => {
    if (Array.isArray(apiData?.results)) {
      return apiData.results.map((r) => r?.variables || []);
    }
    if (Array.isArray(apiData?.variables)) {
      return [apiData.variables];
    }
    return [];
  }, [apiData?.results, apiData?.variables]);

  const displayData = dynamicData?.filter((el) => el.quadrant == winner?.toUpperCase());

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // // console.log(el.quadrant, quadrantScores?.[el.quadrant])
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, index + 1, "in_focus");
    if (res?.averageScore !== null && quadrantScores?.[el.quadrant] == quadrantScores?.[winner?.toUpperCase()]) {
      allResults.push({
        ...res,
        question: el.question
      });
    }
  })

  const top3Questions = allResults?.sort((a, b) => b.averageScore - a.averageScore)?.splice(0, 3)

  useEffect(() => {
    if (!winner) return;
    const out = {
      highestQuadrant: winner,
      quadrantPercentages: {
        strategic: valuesSVPC[0],
        visionary: valuesSVPC[1],
        performance: valuesSVPC[2],
        collaborative: valuesSVPC[3],
      },
    };
    onDataCalculated?.(out);
  }, [winner, valuesSVPC, onDataCalculated]);

  return (
    <div>
      <HeaderPreview apiData={apiData} />
      <div className="about-report-section">
        <h4 className="overview-chart-title">Group LEADERSHIP STYLE OVERVIEW CHART</h4>
        <div className="overview-content">

          <LeaderShipStarterChart originalData={dataForPolar}
            labels={labels}
            ch="strategic"
            position="center"

          />

        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
